bovoApp.controller('PricingController', ['$scope', 'Pricing', '$location', '$routeParams', '$filter', '$translate', '$interval',
  function ($scope, Pricing, $location, $routeParams, $filter, $translate, $interval) {
    $scope.deleted = [];
    $scope.repricePoll = null;

    $scope.all = function () {
      Pricing.all().success(function (data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.openDetail = function (item) {
      Pricing.get(item.id).success(function (data, status, headers, config) {
        $('#pricingModal').modal('show');
        $scope.pricing = data.pricing;
        $scope.formData = data;
        $scope.getTables($scope.pricing, true);
        $scope.pricing.actives = [];
        $scope.pricing.active_cities.forEach(element => {
          $scope.pricing.actives[element.pricing_city_id] = true;
        });
      });
    }

    $scope.$on('new_data', function () {
      $('#pricingModal').modal('show');
      $scope.new();
    }, true);

    $scope.new = function () {
      Pricing.new().success(function (data, status, headers, config) {
        $scope.formData = data;
        $scope.pricing = {
          name: 'TABLO',
          status: 'active',
          company_customer_id: 0,
          customer_group_id: 0,
          exit_city_id: 0,
          sms_price: 0,
          return_rate: 0,
          second_delivery_fee: 0,
          prices: [],
          actives: []
        };
      });
    }

    $scope.getTables = function (pricing, set = false) {
      Pricing.getTables(pricing).success(function (data, status, headers, config) {
        $scope.formData.tables = data.tables;
        if (set) {
          var prices = [];
          $scope.pricing.prices.forEach(element => {
            if (!Array.isArray(prices[element.pricing_weight_id])) {
              prices[element.pricing_weight_id] = [];
            }
            prices[element.pricing_weight_id][element.pricing_city_id] = element.price
          });
  
          $scope.pricing.prices = prices;
        }
      });
    }

    $scope.filterCities = function (pricingCities, pricingCityId) {
      if (pricingCities && pricingCityId) {
        return pricingCities.filter(function (i) { return i.id == pricingCityId })
      }
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        Pricing.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post($scope.translate('Silindi'));
          $scope.all();
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.postForm = function (user) {
      if ($scope.pricing.id) {
        $scope.update();
      } else {
        $scope.save();
      }
    }

    $scope.save = function () {
      Pricing.save($scope.pricing).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#pricingModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.update = function () {
      Pricing.update($scope.pricing).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        var updatedId = $scope.pricing.id;
        var updatedName = $scope.pricing.name;
        $('#pricingModal').modal('hide');
        $scope.all();
        // Fiyat listesi değişti — bu listeyle fiyatlanmış + faturası kesilmemiş
        // siparişleri arka planda yeniden fiyatlama seçeneği sun.
        $scope.openReprice(updatedId, updatedName);
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    // -----------------------------------------------------------------
    // Yeniden fiyatlama (reprice) — fiyat listesi güncellendikten sonra
    // -----------------------------------------------------------------

    // Onay modalini açar ve etkilenecek sipariş sayısını çeker.
    $scope.openReprice = function (pricingId, pricingName) {
      $scope.stopRepricePoll();
      $scope.reprice = {
        id: pricingId,
        name: pricingName,
        from: null,
        to: null,
        count: null,
        counting: false,
        running: false,
        started: false,
        importId: null,
        progress: null
      };
      $('#repriceModal').modal('show');
      $scope.refreshRepriceCount();
    }

    // Seçili tarih aralığına göre kaç siparişin etkileneceğini önizler.
    $scope.refreshRepriceCount = function () {
      if (!$scope.reprice || !$scope.reprice.id) {
        return;
      }
      $scope.reprice.counting = true;
      $scope.reprice.count = null;
      Pricing.repriceCount({
        id: $scope.reprice.id,
        from: $scope.reprice.from,
        to: $scope.reprice.to
      }).success(function (data) {
        $scope.reprice.count = data.count;
        $scope.reprice.counting = false;
      }).error(function (data) {
        $scope.reprice.counting = false;
        Messenger().post({
          message: (data && data.message) ? data.message : 'Sayım yapılamadı',
          type: "error"
        });
      });
    }

    // Onaylanınca yeniden fiyatlamayı arka plana (kuyruğa) gönderir ve
    // ilerleme takibini (polling) başlatır. Modal açık kalır, kullanıcı
    // kaç siparişin işlendiğini/kaldığını canlı görür.
    $scope.confirmReprice = function () {
      if (!$scope.reprice || !$scope.reprice.id || $scope.reprice.running) {
        return;
      }
      $scope.reprice.running = true;
      Pricing.reprice({
        id: $scope.reprice.id,
        from: $scope.reprice.from,
        to: $scope.reprice.to
      }).success(function (data) {
        $scope.reprice.running = false;
        if (data.message === 'NO_ORDERS' || data.total === 0) {
          $('#repriceModal').modal('hide');
          Messenger().post('Bu listeyle fiyatlanmış, faturası kesilmemiş sipariş bulunamadı.');
          return;
        }
        // İlerleme moduna geç.
        $scope.reprice.importId = data.import_id;
        $scope.reprice.started = true;
        $scope.reprice.progress = {
          done: false,
          percent: 0,
          total_orders: data.total,
          processed: 0,
          updated: 0,
          failed: 0,
          remaining: data.total,
          total_jobs: data.dispatched,
          completed_jobs: 0,
          pending_jobs: null
        };
        $scope.startRepricePoll();
      }).error(function (data) {
        $scope.reprice.running = false;
        Messenger().post({
          message: (data && data.message) ? data.message : 'Yeniden fiyatlama başlatılamadı',
          type: "error"
        });
      });
    }

    // İlerleme durumunu periyodik olarak sorgular.
    $scope.startRepricePoll = function () {
      $scope.stopRepricePoll();
      var poll = function () {
        if (!$scope.reprice || !$scope.reprice.importId) {
          return;
        }
        Pricing.repriceStatus($scope.reprice.importId).success(function (data) {
          if (!$scope.reprice) {
            return;
          }
          $scope.reprice.progress = data;
          if (data.done) {
            $scope.stopRepricePoll();
          }
        }).error(function () {
          // Geçici hata olabilir; polling devam etsin.
        });
      };
      poll(); // hemen bir kez
      $scope.repricePoll = $interval(poll, 3000);
    }

    $scope.stopRepricePoll = function () {
      if ($scope.repricePoll) {
        $interval.cancel($scope.repricePoll);
        $scope.repricePoll = null;
      }
    }

    // Özet cari kırılımını CSV olarak indir.
    $scope.downloadRepriceCsv = function () {
      if ($scope.reprice && $scope.reprice.importId) {
        window.open(Pricing.repriceCsvUrl($scope.reprice.importId), '_blank');
      }
    }

    $scope.closeReprice = function () {
      $scope.stopRepricePoll();
      $('#repriceModal').modal('hide');
    }

    // Controller yok olurken polling'i temizle (bellek sızıntısı olmasın).
    $scope.$on('$destroy', function () {
      $scope.stopRepricePoll();
    });

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

    $scope.addPrice = function (workType, type) {
      $scope.pricing.prices.push({
        min_weight: null,
        type: 'weight',
        work_type: workType,
        price_type: type
      });
    }

    $scope.removePrice = function (item) {
      var index = $scope.pricing.prices.findIndex(function (elm) {
        return elm.$$hashKey == item.$$hashKey
      })
      $scope.pricing.prices.splice(index, 1);
    }

  }
]);